import  { useState , useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { removeProductFromCart, submitOrderInit } from '../../store/actions/index';
import { formatCurrency } from '../../shared/utility';
import CartProduct from '../../components/CartProduct/CartProduct'
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const Container = styled.div`
    min-height: 100vh;
    padding: 5%;
`;
const CartTotal = styled.span`
    font-size: 20px;
    line-height:1.5;
    color: #000;
    font-weight:600;
    text-transform: capitalize;
`
const CartPrice = styled.p`
    display: flex;
    background-color: #fff;
    align-items: center;
    justify-content: space-between;
    padding:30px;
    color: #333;
    font-size: 18px;
    margin:0;
    text-align: left;
    font-weight: 700;
    border-radius: 8px;
`
const CartMeessage = styled.p`
    display: flex;
    background-color: #fff;
    align-items: center;
    justify-content: center;
    padding:30px;
    color: #333;
    font-size: 18px;
    margin:0;
    font-weight: 700;
    border-radius: 8px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
`
const CheckoutAction = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0;
`
const Button = styled.button`
    font-size:17px;
    padding:15px 30px;
    background-color: ${ props => props.primary ? '#027897' : '#ff5722' };
    color: #fff;
    border:0;
    outline: none;
    cursor: pointer;
    text-transform: capitalize;
    border-radius: 4px;
    transition: 0.3s ease-in-out;
    margin-left: 20px;
    &:hover {
        background-color: #f44040;
    }
`

const Cart = props => {
    const { cartItems ,  removeProduct , proccedToCheckoutHandler } = props;

    const [ totalPrice , setTotalPrice ] = useState(0);

    const history = useHistory();


    const checkedOutHandler = useCallback(
        ( ) => {
            proccedToCheckoutHandler();
            history.push(`/checkout`);
        },
        [  history , proccedToCheckoutHandler ],
    )
    const cancelCheckedOutHandler = useCallback(
        ( ) => {
            history.push('/')
        },
        [ history ],
    )


    const removeItemHandler = useCallback( ( id ) => {
        removeProduct(id);
    },[ removeProduct ])


    const totalPriceHandler = useCallback( ( ) => {
        const updatePrice = cartItems.reduce((sum, entry) => {
            return sum + ( (entry.priceCents * entry.quantity ) / 100 )
        }, 0)
        setTotalPrice(updatePrice);
    }, [ cartItems ])

    useEffect(() => {
        totalPriceHandler();
    }, [ cartItems , totalPriceHandler]);

    let fetchedCartItems = <CircularProgress />;

    if ( cartItems.length === 0 ) {
        fetchedCartItems = <CartMeessage>Cart Is Empty Buy Something</CartMeessage>
    }
    else {
        fetchedCartItems = cartItems.map( item => {
            return <CartProduct key={item.id} id={item.orderId} img={ '#'+ item.imageColor} name={item.name} 
            price= {formatCurrency( ( item.priceCents / 100 ) * item.quantity )} quantity={item.quantity} remove={removeItemHandler} />
        })
    }

    return(
        <Container>
            {fetchedCartItems}
            {cartItems.length !== 0 ? <CartPrice><CartTotal>total:</CartTotal> {formatCurrency(totalPrice)}</CartPrice> : null}
            {cartItems.length !== 0 ?
                <CheckoutAction>
                    <Button primary onClick={checkedOutHandler}>Procced</Button>
                    <Button onClick={cancelCheckedOutHandler}>go back</Button>
                </CheckoutAction>
                : null
            }
            {cartItems.length === 0 &&
                <CheckoutAction>
                    <Button onClick={cancelCheckedOutHandler}>go back</Button>
                </CheckoutAction>
            }
        </Container>
    )
}

const mapStateToProps = state =>{
    return {
        cartItems: state.cart.cartItems,
        cartQuantity: state.cart.cartQuantity,
    }
}
const mapDispatchToProps = dispatch =>{
    return {
        removeProduct: ( id ) => dispatch( removeProductFromCart( id ) ),
        proccedToCheckoutHandler: ( ) => dispatch( submitOrderInit( ) )
    }
}


export default connect( mapStateToProps , mapDispatchToProps )(Cart);